import { get, patch, post } from "api/api";
import { STUDENT_PROGRESS_ENDPOINTS } from "api/endpoints/student-progress";
import { TEditExercise, TExercise } from "types/api/exercise";
import { TStudentProgress, TStudentProgressByType } from "types/api/progress";
import { TUrlParam } from "types/utils";

export const getChapterStudentProgress = (
  courseId: TUrlParam,
  lessonId: TUrlParam,
  chapterId: TUrlParam,
  studentId: TUrlParam
): Promise<TExercise[]> =>
  get<TExercise[]>(
    STUDENT_PROGRESS_ENDPOINTS.CHAPTER_STUDENT_PROGRESS(
      courseId,
      lessonId,
      chapterId,
      studentId
    )
  );

export const updateChapterStudentProgress = <
  TPayload = Record<string, unknown>,
  TText extends string = string
>(
  courseId: TUrlParam,
  lessonId: TUrlParam,
  chapterId: TUrlParam,
  studentId: TUrlParam,
  exercise: TEditExercise<TPayload, TText>
): Promise<TExercise<TPayload, TText>> =>
  post<TExercise<TPayload, TText>>(
    STUDENT_PROGRESS_ENDPOINTS.CHAPTER_STUDENT_PROGRESS(
      courseId,
      lessonId,
      chapterId,
      studentId
    ),
    exercise
  );

export const getHomeworkStudentProgress = (
  courseId: TUrlParam,
  lessonId: TUrlParam,
  homeworkId: TUrlParam,
  studentId: TUrlParam
): Promise<TExercise[]> =>
  get<TExercise[]>(
    STUDENT_PROGRESS_ENDPOINTS.HOMEWORK_STUDENT_PROGRESS(
      courseId,
      lessonId,
      homeworkId,
      studentId
    )
  );

export const updateHomeworkStudentProgress = <
  TPayload = Record<string, unknown>,
  TText extends string = string
>(
  courseId: TUrlParam,
  lessonId: TUrlParam,
  chapterId: TUrlParam,
  studentId: TUrlParam,
  exercise: TEditExercise<TPayload, TText>
): Promise<TExercise<TPayload, TText>> =>
  post<TExercise<TPayload, TText>>(
    STUDENT_PROGRESS_ENDPOINTS.HOMEWORK_STUDENT_PROGRESS(
      courseId,
      lessonId,
      chapterId,
      studentId
    ),
    exercise
  );

export const moveHistoriesToHomework = (
  studentId: TUrlParam,
  courseId: TUrlParam,
  lessonId: TUrlParam,
  historyIds: number[]
): Promise<unknown> =>
  patch(
    STUDENT_PROGRESS_ENDPOINTS.MOVE_TO_HOMEWORK(studentId, courseId, lessonId),
    historyIds
  );

export const moveHistoriesToClass = (
  studentId: TUrlParam,
  courseId: TUrlParam,
  lessonId: TUrlParam,
  historyIds: number[]
): Promise<unknown> =>
  patch(
    STUDENT_PROGRESS_ENDPOINTS.MOVE_TO_CLASS(studentId, courseId, lessonId),
    historyIds
  );

export const getStudentProgress = (): Promise<TStudentProgress[]> =>
  get<TStudentProgress[]>(STUDENT_PROGRESS_ENDPOINTS.STUDENT_PROGRESS);

export const getStudentProgressByType = (): Promise<TStudentProgressByType[]> =>
  get<TStudentProgressByType[]>(
    STUDENT_PROGRESS_ENDPOINTS.STUDENT_PROGRESS_BY_TYPE
  );

export const uploadAudio = (audioBlob: Blob): Promise<string> => {
  const formData = new FormData();
  formData.append("file", audioBlob, "recording.webm");
  return post<string>(STUDENT_PROGRESS_ENDPOINTS.AUDIO_UPLOAD, formData, {
    headers: { "Content-Type": undefined },
  });
};
